import React, { useEffect, useState } from 'react';
import {
  ButtonContainer,
  LeftColumn,
  RightColumn,
} from './ReceptionList.styled';
import toISODateOnlyString from '../../../utils/toISODateOnlyString';
import isDate from '../../../utils/isDate';
import { RouteButton } from '../../form/routeButton';
import { Link, useLocation } from 'react-router-dom';
import { useAuthentication } from '../../authentiction';
import { useMediaQuery } from 'beautiful-react-hooks';
import { parse } from '../../../utils/queryString';
import { IReceptionListFilterBarProps } from './types';

export const ReceptionListFilterBar: React.FC<IReceptionListFilterBarProps> = ({
  selectedDate,
  visitorTypeId,
  isToday,
  tableMode,
  showSignedOutVisitors,
  onDateChange,
  onVisitorTypeIdChange,
  onTableModeChanged,
  onShowSignedOutVisitorsChange,
}) => {
  const isLarge = useMediaQuery('(min-width: 769px)');

  const { search } = useLocation();

  const { retainDataForInDays, visitorTypes } = useAuthentication();

  const [minimumDate, setMinimumDate] = useState<string>('');
  const [editableDate, setEditableDate] = useState<string>(selectedDate);

  // minimum date
  useEffect(() => {
    const date = new Date();
    date.setDate(date.getDate() - (retainDataForInDays ?? 365));
    setMinimumDate(toISODateOnlyString(date));
  }, [selectedDate, retainDataForInDays]);

  // query string
  useEffect(() => {
    const { mode, filter } = parse(search);

    onTableModeChanged(mode?.toString().toLowerCase() === 'table');
    onShowSignedOutVisitorsChange(filter?.toString().toLowerCase() !== 'true');
  }, [search, onTableModeChanged, onShowSignedOutVisitorsChange]);

  const handleSelectedDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isDate(e.currentTarget.value)) {
      console.log(e.currentTarget.value);
      onDateChange(e.currentTarget.value);
    }

    setEditableDate(e.currentTarget.value);
  };

  const handleSelectedDateLostFocus = (): void => {
    if (editableDate === '') {
      const today = toISODateOnlyString(new Date());
      setEditableDate(today);
      onDateChange(today);
    } else {
      onDateChange(editableDate);
    }
  };

  return (
    <ButtonContainer>
      <LeftColumn>
        <div className="form-group">
          <label htmlFor="selectedDate">Date</label>
          <input
            id="selectedDate"
            type="date"
            className="form-control"
            min={minimumDate}
            max={toISODateOnlyString(new Date())}
            value={editableDate}
            onChange={handleSelectedDateChange}
            onBlur={handleSelectedDateLostFocus}
          />
        </div>
        <div className="form-group">
          <label htmlFor="visitorTypeId">Visitor Type</label>
          <select
            id="visitorTypeId"
            className="form-control"
            value={visitorTypeId}
            onChange={(e) => onVisitorTypeIdChange(e.currentTarget.value)}
          >
            <option value="">All</option>
            {visitorTypes?.allIds.map((id) => (
              <option
                key={visitorTypes?.byId[id].id.toString()}
                value={visitorTypes?.byId[id].id.toString()}
              >
                {visitorTypes?.byId[id].name}
              </option>
            ))}
          </select>
        </div>
      </LeftColumn>
      <RightColumn>
        {isToday && (
          <RouteButton to={`/reception/signIn${search}`} variant="primary">
            Sign In
          </RouteButton>
        )}
        <div className="flex-grow-1" />
        {isLarge && (
          <Link
            to={`/reception?mode=${
              tableMode ? 'card' : 'table'
            }&filter=${(!showSignedOutVisitors).toString()}`}
            className="btn btn-secondary"
          >
            {tableMode ? 'Switch to Card View' : 'Switch to Table View'}
          </Link>
        )}
        {isToday && (
          <Link
            to={`/reception?mode=${
              tableMode ? 'table' : 'card'
            }&filter=${showSignedOutVisitors.toString()}`}
            className="btn btn-info"
          >{`${
            showSignedOutVisitors ? 'Hide' : 'Show'
          } Signed Out Visitors`}</Link>
        )}
      </RightColumn>
    </ButtonContainer>
  );
};
